<template>
<div>
  <div class="content has-text-centered has-background-white">
    <img src="../assets/mperaheader.png" height="100px">
  </div>
  <!-- <section class="section has-background-grey-lighter"> -->

  <form id="mainpage" @submit.prevent="processPage1">

    <div class="container">
      <div class="box">
        <div class="container">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">Select Retirement System</label>
            </div>
            <p class="control is-expanded">
              <b-select placeholder="Select Retirement System" name="retsys" v-model="calcData.retsys" required>
                <option value="PERS">Public Employee Retirement System (PERS)</option>
                <!-- <option value="FURS">Firefighters' United Retirement System</option>
                <option value="MPORS">Municipal Police Officers' Retirement System</option> -->
              </b-select>
            </p>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="container">
      <div class="box">
        <div class="content has-text-centered">
          <h5 class="title is-5">Employment Information</h5>
        </div>
        <div class="box">
          <div class="container">
            <div class="field is-grouped">
              <div class="field-label">
                <label class="label">Hire Date</label>
              </div>
              <p class="control is-expanded">
                <b-datepicker id="hiredate" v-model="calcData.hiredate" placeholder="MM/DD/YYYY" icon="calendar-today" editable required></b-datepicker>
              </p>
              <div class="field-label">
                <label class="label">Annual Salary</label>
              </div>
              <p class="control is-expanded">
                <b-input id="annsalary" placeholder="Annual Salary" v-model="calcData.annsalary" type="number" min="1" max="200000"></b-input>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="container">
      <div class="container">
        <div class="box">
          <div class="content has-text-centered">
            <h5 class="title is-5">Service Information</h5>
          </div>
          <div class="box">
            <table class="table is-fullwidth">
              <div class="content">

                <tbody>
                  <tr>
                    <td width="50%">&nbsp;</td>
                    <td width="25%">Years&nbsp;</td>
                    <td width="25%">Months&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="50%">Service Credit</td>
                    <td width="25%">
                      <p class="control is-expanded">
                        <b-input placeholder="Service Credit Years" id="scYears" v-model="calcData.scYears" v-on:blur="chkServiceBlank('scy')" type="number" min="0" max="50"></b-input>
                      </p>
                    </td>
                    <td width="25%">
                      <p class="control is-expanded">
                        <b-input placeholder="Service Credit Months" id="scMonths" v-model="calcData.scMonths" v-on:blur="chkServiceBlank('scm')" type="number" min="0" max="50"></b-input>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;Membership Service</td>
                    <td>
                      <p class="control is-expanded">
                        <b-input placeholder="Membership Service Years" id="msYears" v-model="calcData.msYears" v-on:blur="chkServiceBlank('msy')" type="number" min="0" max="50"></b-input>
                      </p>
                    </td>
                    <td>
                      <p class="control is-expanded">
                        <b-input placeholder="Service Credit Years" id="msMonths" v-model="calcData.msMonths" v-on:blur="chkServiceBlank('msm')" type="number" min="0" max="50"></b-input>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </div>
            </table>
          </div>
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">Effective Date for Above Service</label>
            </div>
            <p class="control is-expanded">
              <b-datepicker id="effdate" v-model="calcData.disp_effdate" placeholder="MM/DD/YYYY" icon="calendar-today" editable required></b-datepicker>
            </p>
            <div class="field-label">
              <label class="label"></label>
            </div>
            <p class="control is-expanded">
            </p>
          </div>
        </div>
      </div>
    </div>
  </form>
  <br>
  <section>
    <b-message id="msg" type="is-danger" style="display: none">
      <li v-for="message in messages">
        {{ message }}
      </li>
    </b-message>
  </section>
  <br>
  <div class="columns">
    <div class="column">
    </div>
    <div class="column">
    </div>
    <div class="column">
    </div>
    <div class="column">
      <b-field horizontal>
        <button class="button" id="nextButton" v-on:click="processPage1()">
          <span>Next</span>
          <b-icon icon="arrow-right-bold"></b-icon>
        </button>
      </b-field>
    </div>
  </div>
</div>
</template>


<script>
export default {
  name: "Home",
  data: function() {
    return {
      errMessag: "test message",
      messages: []
    }
  },
  props: ["calcData"],
  computed: {
    scDecimal: function() {
      var m = 0
      var y = 0
      var d = 0
      y = parseInt(this.calcData.scYears)
      m = parseInt(this.calcData.scMonths)
      d = (y * 12) + m
      return d
    },
    msDecimal: function() {
      var m = 0
      var y = 0
      var d = 0
      if (this.calcData.msYears == "") {
        this.calcData.msYears = 0
      }
      if (this.calcData.msMonths == "") {
        this.calcData.msMonths = 0
      }
      y = parseInt(this.calcData.msYears)
      m = parseInt(this.calcData.msMonths)
      d = (y * 12) + m
      return d
    },
    scDecimal: function() {
      var m = 0
      var y = 0
      var d = 0
      if (this.calcData.scYears == "") {
        this.calcData.scYears = 0
      }
      if (this.calcData.scMonths == "") {
        this.calcData.scMonths = 0
      }
      y = parseInt(this.calcData.scYears)
      m = parseInt(this.calcData.scMonths)
      d = (y * 12) + m
      return d
    }
  },
  methods: {
    chkServiceBlank: function(inFlag) {
      var msgElement = document.getElementById("msg")
      msgElement.style.display = "none"

      switch (inFlag) {
        case "scy":
          var scYearsElement = document.getElementById("scYears")
          scYearsElement.classList.remove("is-danger");
          if (this.calcData.scYears == "") {
            this.calcData.scYears = 0
          }
          break;
        case "scm":
          var scMonthsElement = document.getElementById("scMonths")
          scMonthsElement.classList.remove("is-danger");
          if (this.calcData.scMonths == "") {
            this.calcData.scMonths = 0
          }
          break;
        case "msy":
          var msYearsElement = document.getElementById("msYears")
          msYearsElement.classList.remove("is-danger");
          if (this.calcData.msYears == "") {
            this.calcData.msYears = 0
          }
          break;
        case "msm":
          var msMonthsElement = document.getElementById("msMonths")
          msMonthsElement.classList.remove("is-danger");
          if (this.calcData.msMonths == "") {
            this.calcData.msMonths = 0
          }
          break;
        default:
          alert("other")
      }
    },

    processPage1: function(event) {
      var msgElement = document.getElementById("msg")
      var hiredateElement = document.getElementById("hiredate")
      var annsalaryElement = document.getElementById("annsalary")
      var scYearsElement = document.getElementById("scYears")
      var scMonthsElement = document.getElementById("scMonths")
      var msYearsElement = document.getElementById("msYears")
      var msMonthsElement = document.getElementById("msMonths")
      var editsPassed = true
      var localMessages = []

      msgElement.style.display = "none"

      if (this.calcData.annsalary > 0) {
        //OK
        annsalaryElement.classList.remove("is-danger");
      } else {
        editsPassed = false
        annsalaryElement.classList.add("is-danger");
        localMessages.push("Please Enter Annual Salary")
      }
      if (this.calcData.hiredate > "") {
        //OK
        hiredateElement.classList.remove("is-danger");
      } else {
        editsPassed = false
        hiredateElement.classList.add("is-danger");
        localMessages.push("Please Enter/Select Hire Date")
      }

      if (this.scDecimal <= 0) {
        editsPassed = false
        localMessages.push("Please Enter Service Credit")
        scYearsElement.classList.add("is-danger");
        scMonthsElement.classList.add("is-danger");
      } else {
        scYearsElement.classList.remove("is-danger");
        scMonthsElement.classList.remove("is-danger");
      }
      if (this.msDecimal <= 0) {
        editsPassed = false
        localMessages.push("Please Enter Membership Service")
        msYearsElement.classList.add("is-danger");
        msMonthsElement.classList.add("is-danger");
      } else {
        msYearsElement.classList.remove("is-danger");
        msMonthsElement.classList.remove("is-danger");
      }

//========= Check for Edit Passage =========================================
      if (editsPassed) {
        var hd = new Date()
        hd= this.calcData.hiredate
        this.calcData.disp_hiredate = (hd.getMonth() + 1) + "/" + hd.getDay() + "/" + (hd.getYear()+1900)
        this.$router.push('page02')
      } else {
        msgElement.style.display = "block"
      }
      this.messages = localMessages
    },
    calcscDecimal: function() {
      var m = 0
      var y = 0
      var d = 0
      y = parseInt(this.calcData.scYears)
      m = parseInt(this.calcData.scMonths)
      d = (y * 12) + m
      this.calcData.scDecimal = d
    }

  }

};
</script>
